// extracted by mini-css-extract-plugin
module.exports = {"rotate":"SwitchToChronoMode_rotate__2ZasH","switchMenu":"SwitchToChronoMode_switchMenu__3X8wY","option":"SwitchToChronoMode_option__1DnF5"};